module.exports = "/packs/media/images/icons/switching-597e47db8c5ac0f3871d2d9e5a8c0479.png";